import { Panel } from 'component/Space/Panel'
import { observer } from 'mobx-react-lite'
import { Shape } from 'page/ProfileScreen/Shapes/Shape'
import { store } from 'store/store'

export const Shapes = observer(() => {
  const { shape_types } = store.profile.form.cfg

  return <Panel>
    {shape_types.map(type => <Shape key={type} type={type} />)}
  </Panel>
})
